import { render, staticRenderFns } from "./ContractManagement.vue?vue&type=template&id=65b8dbff&scoped=true&"
import script from "./ContractManagement.vue?vue&type=script&lang=js&"
export * from "./ContractManagement.vue?vue&type=script&lang=js&"
import style0 from "./ContractManagement.vue?vue&type=style&index=0&id=65b8dbff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8dbff",
  null
  
)

export default component.exports